import React from 'react';
import { getStatusColor } from '../utils/euStatusUtils';
import '../utils/sharedStyles.css';

// Status semaphore component (colored circle) — size tuned to sit alongside ~0.875rem text
export const StatusSemaphore = ({ category, score, size = 18, showCaption = true }) => {
  const color = getStatusColor(category);
  const displayScore = score !== null && score !== undefined ? `${Math.round(score)}%` : 'N/A';

  return (
    <div className={`goal-assessment-icon-container${showCaption ? '' : ' goal-assessment-icon-container--icon-only'}`}>
      <div
        className="goal-assessment-icon"
        style={{
          width: size,
          height: size,
          borderRadius: '50%',
          backgroundColor: color,
          border: '2px solid #fff',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        }}
        title={category || 'Status not available'}
      />
      {showCaption && (
        <div>
          <div className="goal-assessment-text">
            {category || 'Not applicable'}
          </div>
          {score !== null && score !== undefined && (
            <div style={{ fontSize: '0.75rem', color: '#666' }}>
              {displayScore}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default StatusSemaphore;
